import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;


export function getBeneficiaries(perPage = 10, page = 1){
  const url = `${BASE_URL}/beneficiaries`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    params:{
      per_page:perPage,
      page:page,
    }
  })
}

export function blacklistBeneficiary(beneficiaryId){
  const url = `${BASE_URL}/beneficiaries/blacklist`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      merchantId,
      beneficiaryId,
    }
  })
}

export function deleteBlacklistedBenef(beneficiaryId){
  const url = `${BASE_URL}/beneficiaries/blacklist`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'delete',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data:{
      merchantId,
      beneficiaryId,
    }
  })
}

export function deleteBeneficiary(beneficiaryId){
  const url = `${BASE_URL}/beneficiaries/` + beneficiaryId;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'delete',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    }
  })
}

export function createBeneficiaries(dataObj){
  if(dataObj.branchCode === ""){
    dataObj.branchCode = null;
  }
  const url = `${BASE_URL}/beneficiaries`;
  let token = getCookie('token');
  let merchantId = window.localStorage.getItem('merchantId');
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
      'Authorization':token,
      'merchant-id':merchantId
    },
    data: {
      account_number: dataObj.accountNumber,
      name: dataObj.name,
      bank_code: Array.isArray(dataObj.bankCode) ? dataObj.bankCode[1] : dataObj.bankCode,
      meta: dataObj.branchCode ? JSON.stringify({branchCode: dataObj.branchCode}) : null,
      phone_number: dataObj.phone_number,
      email: dataObj.email,
      country: dataObj.country,
      currency: dataObj.currency
    }
  })
}


// WEBPACK FOOTER //
// ./src/utils/wallet-transactions/beneficiariesService.js